import { Injectable } from '@angular/core';
import { NestApiProvider } from '../../nest-api';
import { ResponseData } from '../../nest-responses';
import {
  RequestAddUpdateEmpStatusDto,
  RequestDeleteEmpStatusDto, RequestParamsGetEmpStatusDetail, ResponseGetEmpStatusListingDto
} from '../dto/emp-status-setting.dto';

@Injectable()
export class EmpStatusSettingApi {

  private readonly service: string = '';
  private readonly model: string = 'employmentStatus';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public getEmpStatusList() {

    const method: string = 'GET';
    const func: string = 'getData';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetEmpStatusListingDto>>(method, url, params, urlParams, body);
  }

  public getEmpStatusDetail(queryParams: RequestParamsGetEmpStatusDetail) {
    const method: string = 'GET';
    const func: string = 'getStatus';
    const params: any = {};
    const urlParams: any = queryParams;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetEmpStatusListingDto>>(method, url, params, urlParams, body);
  }

  public createEmpStatus(payload: RequestAddUpdateEmpStatusDto) {
    const method: string = 'POST';
    const func: string = 'createStatus';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public updateEmpStatus(payload: RequestAddUpdateEmpStatusDto) {
    const method: string = 'POST';
    const func: string = 'updateStatus';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public deleteEmpStatus(payload: RequestDeleteEmpStatusDto) {
    const method: string = 'POST';
    const func: string = 'deleteStatus';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/emp-status-setting.api.ts